import { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { format } from "date-fns-jalali";
import Logo from "../Images/favicon.png";

function TabIcon({ type }) {
  const icons = {
    statement: (
      <>
        <path d="M7 3.75h10A2.25 2.25 0 0 1 19.25 6v12A2.25 2.25 0 0 1 17 20.25H7A2.25 2.25 0 0 1 4.75 18V6A2.25 2.25 0 0 1 7 3.75Z" />
        <path d="M8 8.25h8M8 12h8M8 15.75h4.5" />
      </>
    ),
    transfer: (
      <>
        <path d="M4.75 7.5h11.5A3 3 0 0 1 19.25 10.5v0A3 3 0 0 1 16.25 13.5H8" />
        <path d="M10.25 10.75 7.5 13.5l2.75 2.75" />
        <path d="M19.25 16.5H7.75A3 3 0 0 1 4.75 13.5v0A3 3 0 0 1 7.75 10.5H16" />
        <path d="M13.75 7.75 16.5 10.5l-2.75 2.75" />
      </>
    ),
    trades: (
      <>
        <path d="M4.75 16.25 9 12l3 3 7.25-7.25" />
        <path d="M15.25 7.75h4v4" />
        <path d="M5.25 19.25h13.5" />
      </>
    ),
    balance: (
      <>
        <path d="M5.75 6.75h12.5A2 2 0 0 1 20.25 8.75v8.5A2 2 0 0 1 18.25 19.25H5.75A2 2 0 0 1 3.75 17.25v-8.5A2 2 0 0 1 5.75 6.75Z" />
        <path d="M16.25 11.25h4v3.5h-4a1.75 1.75 0 0 1 0-3.5Z" />
        <path d="M7.25 6.75V5.5A1.75 1.75 0 0 1 9 3.75h6A1.75 1.75 0 0 1 16.75 5.5v1.25" />
      </>
    ),
    settings: (
      <>
        <path d="M12 8.25A3.75 3.75 0 1 1 12 15.75A3.75 3.75 0 0 1 12 8.25Z" />
        <path d="M12.9 3.75h-1.8l-.55 2.1a6.72 6.72 0 0 0-1.35.56L7.33 5.32 6.06 6.59l1.09 1.87c-.23.43-.42.88-.56 1.35l-2.09.54v1.8l2.09.54c.14.47.33.92.56 1.35l-1.09 1.87 1.27 1.27 1.87-1.09c.43.23.88.42 1.35.56l.55 2.1h1.8l.55-2.1c.47-.14.92-.33 1.35-.56l1.87 1.09 1.27-1.27-1.09-1.87c.23-.43.42-.88.56-1.35l2.09-.54v-1.8l-2.09-.54a6.72 6.72 0 0 0-.56-1.35l1.09-1.87-1.27-1.27-1.87 1.09a6.72 6.72 0 0 0-1.35-.56l-.55-2.1Z" />
      </>
    ),
  };

  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      {icons[type]}
    </svg>
  );
}

function TopNavigator() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [currentDate, setCurrentDate] = useState({ dayName: "", dateStr: "" });
  const menuRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    const userData = localStorage.getItem("user");

    if (token && userData) {
      try {
        setUser(JSON.parse(userData));
      } catch (error) {
        console.error("Error parsing user data:", error);
        setUser(null);
      }
      return;
    }

    setUser(null);
  }, []);

  useEffect(() => {
    const today = new Date();
    const dayName = new Intl.DateTimeFormat("fa-IR-u-ca-persian", {
      weekday: "long",
    }).format(today);
    const dateStr = format(today, "yyyy/MM/dd");
    setCurrentDate({ dayName, dateStr });
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menuOpen]);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setMenuOpen(false);
        setAuthModalOpen(false);
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
    setMenuOpen(false);
    navigate("/");
    window.location.reload();
  };

  const menuItems = [
    { path: "/balance", icon: "💰", label: "موجودی حساب" },
    { path: "/transfer", icon: "💸", label: "ثبت حواله" },
    { path: "/transactions", icon: "📜", label: "گردش حساب" },
    { path: "/price-changes", icon: "📈", label: "تغییرات قیمت امروز" },
    { path: "/settings", icon: "⚙️", label: "تنظیمات" },
  ];

  const bottomTabs = [
    { path: "/transactions", icon: "statement", label: "گردش حساب", requiresAuth: true },
    { path: "/transfer", icon: "transfer", label: "ثبت حواله", requiresAuth: true },
    { path: "/", icon: "trades", label: "معاملات", requiresAuth: false },
    { path: "/balance", icon: "balance", label: "موجودی حساب", requiresAuth: true },
    { path: "/settings", icon: "settings", label: "تنظیمات", requiresAuth: false },
  ];

  const isActivePath = (path) => {
    if (path === "/") {
      return location.pathname === "/";
    }

    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  const handleProtectedTabClick = (event, tab) => {
    if (!user && tab.requiresAuth) {
      event.preventDefault();
      setAuthModalOpen(true);
    }
  };

  return (
    <>
      <div className="Nav">
        <div className="container">
          <div className="RowNav">
            <div className="NavSide NavSideMenu">
              {!user ? (
                <Link to="/register" className="LoginBtn">
                  افتتاح حساب
                </Link>
              ) : (
                <div className="HamburgerMenu" ref={menuRef}>
                  <button
                    className={`HamburgerBtn ${menuOpen ? "Active" : ""}`}
                    onClick={() => setMenuOpen(!menuOpen)}
                    aria-label="منو"
                    aria-expanded={menuOpen}
                  >
                    <span className="Bar"></span>
                    <span className="Bar"></span>
                    <span className="Bar"></span>
                  </button>

                  <div className={`DropdownMenu ${menuOpen ? "Show" : ""}`}>
                    <div className="MenuHeader">
                      <div className="UserAvatar">
                        {user.firstName?.charAt(0) || user.name?.charAt(0) || "؟"}
                      </div>
                      <div className="UserDetails">
                        <span className="UserName">
                          {user.firstName} {user.lastName}
                        </span>
                        <span className="UserPhone">{user.phone || "شماره تماس"}</span>
                      </div>
                    </div>

                    <div className="MenuItems">
                      {menuItems.map((item) => (
                        <Link
                          key={item.path}
                          to={item.path}
                          className="MenuItem"
                          onClick={() => setMenuOpen(false)}
                        >
                          <span className="ItemIcon">{item.icon}</span>
                          <span className="ItemLabel">{item.label}</span>
                          <span className="ItemArrow">‹</span>
                        </Link>
                      ))}
                    </div>

                    <div className="MenuFooter">
                      <button className="LogoutBtn" onClick={handleLogout}>
                        <span className="BtnIcon">🚪</span>
                        <span>خروج از حساب</span>
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="NavCenter">
              <div className="LogoWrap">
                <span className="LogoHalo" aria-hidden="true"></span>
              </div>
              <div className="NavBrandText">
                <p className="NavEyebrow">تابلوی قیمت و معامله</p>
                <h1 className="NavTitle">عزت خواه</h1>
              </div>
            </div>

            <div className="NavSide NavSideDate">
              <div className="NavDateCard">
                <p className="NavDateDay">{currentDate.dayName}</p>
                <p className="NavDateValue">{currentDate.dateStr}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {authModalOpen && (
        <div className="AuthRequiredOverlay" onClick={() => setAuthModalOpen(false)}>
          <div className="AuthRequiredModal" onClick={(event) => event.stopPropagation()}>
            <button
              type="button"
              className="AuthRequiredClose"
              onClick={() => setAuthModalOpen(false)}
              aria-label="بستن"
            >
              ×
            </button>
            <span className="AuthRequiredIcon">
              <TabIcon type="settings" />
            </span>
            <h3>کاربر باید قبلا وارد شود</h3>
            <p>برای دسترسی به این بخش ابتدا وارد حساب کاربری خود شوید.</p>
            <div className="AuthRequiredActions">
              <Link to="/loginpage" className="AuthRequiredPrimary" onClick={() => setAuthModalOpen(false)}>
                ورود
              </Link>
              <button type="button" className="AuthRequiredSecondary" onClick={() => setAuthModalOpen(false)}>
                بستن
              </button>
            </div>
          </div>
        </div>
      )}

      <nav className={user ? "MobileBottomTabs" : "MobileBottomTabs guest"} aria-label="منوی پرتال کاربر">
        {bottomTabs.map((tab) => (
          <Link
            key={tab.path}
            to={tab.path}
            className={[
              isActivePath(tab.path) ? "MobileBottomTab active" : "MobileBottomTab",
              !user && tab.requiresAuth ? "locked" : "",
            ].filter(Boolean).join(" ")}
            aria-label={tab.label}
            title={tab.label}
            onClick={(event) => handleProtectedTabClick(event, tab)}
          >
            <span className="MobileBottomIcon">
              <TabIcon type={tab.icon} />
            </span>
          </Link>
        ))}
      </nav>
    </>
  );
}

export default TopNavigator;
